import { combineReducers } from 'redux';
import categories from './categories';
import blog from './blog';
import job from './job';

export default combineReducers({
    categories,
    blog,
    job
})